import { SelectListItem } from "../../models/utilities/selectlist-item";

const CountryList = [
    {
        name: "United States",
        abbreviation: "US"
    },
    {
        name: "Canada",
        abbreviation: "CA"
    }
];

const CountrySelectList = new Array<SelectListItem<string>>();
CountryList.forEach((itm: any) => {
    CountrySelectList.push(new SelectListItem({
        id: itm.abbreviation,
        name: itm.name
    }));
});

const CountryListDisplayNames: any = {};
CountryList.forEach((itm) => {
    CountryListDisplayNames[itm.abbreviation] = itm.name;
});

export { CountrySelectList, CountryListDisplayNames };
